module.exports = __webpack_public_path__ + "static/media/logo.d9d6df81.webp";